import React from 'react';

export function BattleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.64557 11.5354L8.44138 15.3312L9.1167 14.6559L8.08043 13.6196L17.733 5.3643L18.1056 1.89453L14.5659 2.22053L6.34553 11.8847L5.29761 10.8135L4.64557 11.5354Z"
        fill="#7E3AF2"
      />
      <path
        d="M1.89551 16.6436L5.0534 13.4857L6.5221 14.8936L3.47446 17.9594C2.94814 18.0471 1.89551 17.9068 1.89551 16.6436Z"
        fill="#7E3AF2"
      />
      <path
        d="M7.12263 9.51915L9.3294 6.9191L5.35284 2.2871L1.94434 1.9375L2.27203 5.41149L7.12263 9.51915Z"
        fill="#9061F9"
      />
      <path
        d="M11.558 15.3529L15.3379 11.5511L14.6605 10.8519L13.6336 11.9007L12.7378 10.8519L10.7495 12.6436L11.8421 13.5831L10.7495 14.7193L11.558 15.3529Z"
        fill="#9061F9"
      />
      <path
        d="M13.3715 14.8504L14.8135 13.3865L18.0909 16.6857C18.0327 17.1736 17.6583 18.1408 16.627 18.1059L13.3715 14.8504Z"
        fill="#9061F9"
      />
    </svg>
  );
}
